import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { toastFactory } from '@/factories'
import { resetQueries } from '@/utils/api'
import { getApiErrorMessage } from '@/utils/error'

import { GET_CHECKLIST_TASK_DETAILS_BASE_QUERY_KEY } from './get-checklist-task-details'
import { GET_CHECKLISTS_BASE_QUERY_KEY } from './get-checklists'

interface DeleteChecklistRequest {
  id: number
}

export const deleteChecklist = async (data: DeleteChecklistRequest) => {
  const response = await authAPI.delete(`/checklist-assigned/${data.id}`)
  return response.data
}

export const useDeleteChecklist = () => {
  return useMutation({
    mutationFn: deleteChecklist,
    onError: (error) => {
      toastFactory.error(getApiErrorMessage(error))
    },
    onSuccess: async () => {
      await resetQueries(
        [GET_CHECKLISTS_BASE_QUERY_KEY],
        [GET_CHECKLIST_TASK_DETAILS_BASE_QUERY_KEY],
      )
      toastFactory.success('Checklist deleted successfully')
    },
  })
}
